 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		105: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + {"0":"a6ef1866e481d65514dd","1":"6f7b555036d8d1dcdd79","2":"0db386e27628417aae7a","3":"4ff37327ac972ebb1eaa","4":"a9dd57bd328a576b9440","5":"3379681eff88c91ecd55","6":"e960ffcd73946e5f19d6","7":"4c28d59f4d90699149ed","8":"34dfe49af2a894c87569","9":"686fc052c81b278497ce","10":"6abe2355169ae0e7ed5b","11":"fdf48a61a0eac59037ff","12":"638519c599a4f180164c","13":"eac13564e6833e56b21a","14":"f0e45953f9129e85619d","17":"8c30643313a279e98fba","18":"6beca7b555f7a80466f5","19":"3ba041ee61614360aa65","20":"5f3c16c17723b9210676","21":"69d2dae7fe0f92fe9d15","22":"eab33df72ba7718fe58b","23":"106ad24089812c6870ef","24":"bc7d10a615b97cb625e3","25":"0caddcee5ca5c883dc10","26":"13853b6fc742902605e0","27":"05e8b561d9374c4aa2fc","28":"3b9d4eedfe8e8718542e","29":"8ca98a72cb723f1d97ea","30":"4cc1646340d282497eff","31":"28f632cfb402b86d0170","32":"18fe1ce6651ec37fc3f3","33":"063221a6ababbc6d210d","34":"f7d19c3b6b493cb8935f","35":"59b7cb29ec376465be05","36":"88ba2a06bcfa7099ed34","37":"5ed32978a51c0ae79eb7","38":"99baa4dd3aa67f6f7353","39":"0e5b2311f916f9375f50","40":"4580b99458d84d4d66a3","41":"7f5ac0ef5ada6e20ea80","42":"9e7789402affb1ef6fd5","43":"e82524361ccab5139a79","44":"d9569f478a7c256d2e4e","45":"a0febc94d79a8e28ae71","46":"27a4f690ccb3c1461600","47":"c5d52c12dfae02050140","48":"7bfc947a5e22eacbdc07","49":"ff76f8b86bd918c127ad","50":"248cc5763613fb98150c","51":"9c20c5036791092bf965","52":"ccaf4162a5b0cfbe9fc7","53":"329090d274caf3fff9a7","54":"9850ef0f024f2120dbc9","55":"6689f52d4a78ab2d9ef4","56":"150234d2e95d99327e06","57":"f26e44517ae48b3fd3db","58":"d035c1a061c69b4cf221","59":"f57bcc3e5032ad5f704a","60":"7017a6b61d08bc97234a","61":"b3ccd146496a7afb05d4","62":"58e4795c900a5ca1314f","63":"b22841f488f2a26d7223","64":"3ca483f465ab1c25cee6","65":"dde93715a41cf5548bb5","66":"c08ef5a9c21ed0388fa6","67":"a32a5ea459b565bcf404","68":"0ca78e1db9d9df1dffbb","69":"7f0aed772f1db18a7200","70":"40632fba3e5df5f1200f","71":"f8c7693db480cb106cb6","72":"472b9393c86650094748","73":"9d53fd905b4fc4bffe61","74":"e609d647ceb9f89d48f1","75":"53ae1d2b389a5b1a4307","76":"849ed292697114cb9375","77":"2bb97f9f6fab49171c72","78":"ef7787b911d5d82277e8","79":"2326ebabfdca72538c12","80":"75e9ab75292bc9eff9aa","81":"12e556af9880b3b0bcf5","82":"df226cf2f894f5406b77","83":"2b3201dbbd3ac77a3fb3","84":"98f5f585edfaa4d521d7","85":"960f39cec588e4b749a1","86":"b1f6d8cbdbdd3bbe5db6","87":"9af382abd019f979896b","88":"a9aa59d0635dc63f9c74","89":"37373274fb1965e097b8","90":"4f5e178cbf9a29d328f1","91":"70623800493783858c67","92":"5db82ba8f4d5744104e9","93":"4768425331fd77160615","94":"0ec49545d3903b8116df","95":"8091e41633e0dfd7f45a","96":"1fddf11d0e1207338ec7","97":"8a0ae819bb09323b6da6","98":"45f2552b7470a5ba4909","99":"9291a85cc4d425780b8c","100":"0c0f06b90f92f1c38ded","101":"e28990704c5bbde2d7d7","102":"b115dab7e957d495acbf","103":"8709808d85473267a7e7","104":"401086512cc98c54b72c","107":"aaf3f59703ffd137b9c8","108":"d7f8108543fae7e5788d","109":"ba19143f9dd30c2fbe66","110":"8527df54a0cc36d3cfea","111":"e7fc895481f507787e28","112":"36fc82b4581fcb754a73"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://mediahub.tuoitre.vn/eduzone/_nuxt/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
